import { createV3Queries } from "@query/utils/createV3Queries";
import { accountingConnectionsApi } from "@api";

export const queriesAccountingConnections = createV3Queries(
  "accountingConnectionsApi",
  accountingConnectionsApi
);
